import React, { useState, useEffect } from "react";
import { Chart } from 'react-google-charts';
import client from "../../api";
import {notifyError} from "../../helper";
import DataLoader from "../DataLoader";



const WarmupStatus = (props) => {
    const api = client();
    const handleClose = props.handleClose
    const mailAccountId = props.mailAccountId
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState(null)
    const [errorMsg, setErrorMsg] = useState("")

    const chartOptions = {
        title: 'Warmup Emails Sent',
        isStacked: true,
        legend: { position: 'none' },
        colors: ['#f87171','#22c55e'], // green & red
        chartArea: { width: '80%' },
        vAxis: { minValue: 0 },
        height: 300,
    };

    const fetchWarmupStatus = async () => {
        setLoading(true);
        try {
            const response = await api.get(`/v1/mailAccount/instantly/${mailAccountId}`);
            if (response.status === 200) {
                const rd = response.data
                if(rd.status == 'ok'){
                    const warmupStartTime = (new Date(rd.warmup_start_time * 1000)).toDateString()
                    const aggregateData = {
                        "received": rd.aggregate_result.received,
                        "sent": rd.aggregate_result.sent,
                        "spam": rd.aggregate_result.landed_spam,
                    } 
                    const chartData = [
                        ['Day','Saved from Spam', 'Sent']
                    ];
                    for (const dateKey in rd.date_wise_result) {
                        if (rd.date_wise_result.hasOwnProperty(dateKey)) { // Recommended to check for own properties
                            const dateResult = rd.date_wise_result[dateKey]
                            chartData.push([dateKey, dateResult.landed_spam, dateResult.landed_inbox])
                        }
                    }
                    setData({
                        "warmupEnabled" : !!rd.warmup_status,
                        "warmupStartTime": warmupStartTime,
                        "aggregate": aggregateData,
                        "chartData": chartData
                    });
                }else if (rd.status == "error"){
                    switch(rd.error_code){
                        case 0:
                            setErrorMsg(<p>
                                <strong>Unable to fetch mail account warmup information from instantly</strong><br />
                                Please check it in&nbsp;
                                <a href="https://instantly.ai" target="_blank" rel="noopener noreferrer">Instantly</a>
                                &nbsp;and enable warmup to see data here.
                            </p>)
                            break;
                        case 1:
                            setErrorMsg(<p>
                                <strong>This email account does not seems to be added in Instantly.</strong><br />
                                Please add it in&nbsp;
                                <a href="https://instantly.ai" target="_blank" rel="noopener noreferrer">Instantly</a>
                                &nbsp;and enable warmup to see data here.
                            </p>)
                            break;
                        case 2:
                            setErrorMsg(<p>
                                <strong>Unable to fetch mail account warmup information from instantly</strong><br />
                                Please check it in&nbsp;
                                <a href="https://instantly.ai" target="_blank" rel="noopener noreferrer">Instantly</a>
                                &nbsp;and enable warmup to see data here.
                            </p>)
                            break;
                        default:
                            setErrorMsg(<p>
                                <strong>Unexpected error happened while fetching the warmup information,</strong><br />
                                Please check it after sometime.
                            </p>)
                    }
                }
                else{
                    notifyError("An unexpected error occured. Please try later");
                    handleClose()
                }
            } else if (response.status === 400) {
                notifyError("Not able to fetch the warmup status at this time. Please try after sometime");
                handleClose()
            } else if (response.status === 404){
                notifyError("The mail account does not exists any more.");
                handleClose()
            }else if (response.status === 500){
                notifyError("An unexpected error occured. Please try later");
                handleClose()
            }else{
                notifyError("An unexpected error occured. Please try later");
                handleClose()
            }
        } catch (error) {
            notifyError('Error checking warmup status.');
            handleClose()
        } finally {
            setLoading(false);
        }
    };

    const handleWarmpState = async (warmupStatus) => {
        setLoading(true);
        try {
            const response = await api.post(`/v1/mailAccount/instantly/warmup`,{
                account_id: mailAccountId,
                enable: warmupStatus
            });
            if (response.status === 200) {
                const rd = response.data
                if(rd.status == 'ok'){
                    setData(Object.assign({}, data, {"warmupEnabled":warmupStatus}))
                }else if (rd.status == "error"){
                    switch(rd.error_code){
                        case 0:
                            notifyError("Not able to get mail account information from instantly. Try later!")
                            break;
                        case 1:
                            notifyError("This email account does not seems to be added anymore in Instantly.")
                            break;
                        case 2:
                            notifyError("This email account warmup status cannot be changed now due to restrictions.")
                            break;
                        case 3:
                            notifyError("Please make this mail account active on instantly to change warmup status")
                            break;
                        default:
                            notifyError("An unexpected error occured. Please try later");
                    }
                }
                else{
                    notifyError("An unexpected error occured. Please try later");
                }
            } else if (response.status === 400) {
                notifyError("Not able to fetch the warmup status at this time. Please try after sometime");
            } else if (response.status === 404){
                notifyError("The mail account does not exists any more.");
            }else if (response.status === 500){
                notifyError("An unexpected error occured. Please try later");
            }else{
                notifyError("An unexpected error occured. Please try later");
            }
        } catch (error) {
            notifyError("An unexpected error occured. Please try later");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchWarmupStatus();
    }, []);
    return (
        <div>
            <div className="warmup-model">
                <div className="dashboard-overlay">
                    <div className="dashboard-modal">
                        <button className="dashboard-close" onClick={handleClose}>×</button>
                        <div className="dashboard-wrap">
                            {loading && (
                            <div className="modal-loader-overlay">
                                <div className="spinner"></div>
                            </div>
                            )}
                            {!loading && <>
                            {data?<>
                            <div className="dashboard-header">
                                <span className="emoji">😊</span>
                                <div className="start-date">
                                    <strong>Started on:&nbsp;</strong>
                                    <span>{data.warmupStartTime}</span>
                                </div>
                                <div className="status-toggle">
                                    {data.warmupEnabled?<>
                                    <button className="disable" onClick={()=> handleWarmpState(false)}>Disable</button>
                                    <button className="enable active">Enable</button>
                                    </>:<>
                                    <button className="disable active">Disable</button>
                                    <button className="enable" onClick={()=> handleWarmpState(true)}>Enable</button>
                                    </>}
                                </div>
                            </div>
                            <div className="summary-card">
                                <h3>Summary for past week</h3>
                                <div className="summary-items">
                                    <div><strong>{data.aggregate.received}</strong> warmup emails received</div>
                                    <div><strong>{data.aggregate.sent}</strong> warmup emails sent</div>
                                    <div><strong>{data.aggregate.spam}</strong> saved from spam</div>
                                </div>
                            </div>
                            <div className="bar-chart">
                                <Chart
                                    chartType="ColumnChart"
                                    width="100%"
                                    data={data.chartData}
                                    options={chartOptions}
                                />
                            </div></>:
                            <div className="error-overlay">
                                <div className="error-box">
                                    {errorMsg}
                                </div>
                            </div>}
                            </>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WarmupStatus;
